import React from 'react';
import { SHOPIFY_URL } from '../lib/config';
import { trackAddToCart } from '../lib/metaPixel';
type Variant = 'solid' | 'outline';
interface BuyButtonProps {
  children: React.ReactNode;
  variant?: Variant;
  className?: string;
  size?: 'md' | 'lg';
}
const base = 'inline-flex items-center justify-center rounded-full font-sans font-medium uppercase tracking-[0.14em] transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-ink/40 focus-visible:ring-offset-2 focus-visible:ring-offset-cream';
const sizes = {
  md: 'text-xs px-6 py-3',
  lg: 'text-sm px-9 py-4'
};
const variants: Record<Variant, string> = {
  solid: 'bg-ink text-cream hover:bg-ink-soft shadow-sm hover:shadow-md',
  outline: 'border border-ink/40 text-ink hover:bg-ink hover:text-cream'
};
export function BuyButton({
  children,
  variant = 'solid',
  className = '',
  size = 'md'
}: BuyButtonProps) {
  const isPlaceholder = SHOPIFY_URL.startsWith('#');
  return <a href={SHOPIFY_URL} {...!isPlaceholder ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} onClick={trackAddToCart} data-id="element-27" data-mp="3rejdlnpldcp">
      {children}
    </a>;
}